import {Component, EventEmitter, Input, input, Output} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {MONTHS, TimelineSlide} from "../../../model/timeline";
import {IconComponent} from "../icon/icon.component";
import {Icons} from "../../../model/icon";

@Component({
  selector: 'app-timeline',
  imports: [
    NgIf,
    NgForOf,
    IconComponent
  ],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.scss'
})
export class TimelineComponent {
  @Input() activeYear: number = 0;
  @Input() activeMonth: number = 0;
  @Output() emitActive: EventEmitter<number> = new EventEmitter<number>();
  @Output() leftSwipe: EventEmitter<any> = new EventEmitter();
  @Output() rightSwipe: EventEmitter<any> = new EventEmitter();
  disableMonth: boolean = true;


  permittedYear: {year: number, months: number[]}[] = [
    {
      year: 0,
      months: [5, 6, 7, 8, 9, 10, 11]
    },
    {
      year: 1,
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    {
      year: 2,
      months: [0, 1, 2, 3, 4, 5, 6],
    },
    {
      year: 3,
      months: [0, 1, 5, 6, 8],
    },
    {
      year: 4,
      months: [4],
    },
  ];

  getYears(){
    const years: string[] = [];
    let start = 1941;
    for (let i = 0; i < 5; i++) {
      years.push((start + i).toString());
    }
    return years;
  }

  getMonths(){
    const months: string[] = [];
    for (let i = 0; i < 12; i++) {
      months.push(MONTHS[i]);
    }
    return months;
  }

  getPermitted(index: number) {
    const permitted = this.permittedYear.find(v => v.year == this.activeYear)?.months ?? [];
    return permitted.includes(index);
  }

  sliderSelect(year: number, month: number) {
    this.activeYear = year;
    this.activeMonth = month;
  }

  isPermitted(type: string, index: number) {
    if (type == 'year') {
      return this.permittedYear.findIndex(v => v.year == index) > -1;
    } else {
      const yearIdx = this.permittedYear.findIndex(v => v.year == this.activeYear);
      if (yearIdx > -1) {
        return  this.permittedYear[yearIdx].months.findIndex(v => v == index) > -1;
      } else {
        return false;
      }
    }
  }

  left() {
    this.leftSwipe.emit();
  }

  right() {
    this.rightSwipe.emit();
  }


  select(index: number, type: string) {
    if (type == 'year') {
      if(!this.isPermitted('year', index)) return;
      if (index == this.activeYear) {
        this.disableMonth = !this.disableMonth;
      } else {
        this.activeYear = index;
        this.activeMonth = this.permittedYear[index].months[0];
        this.emitActive.emit(this.activeYear * 12  + this.activeMonth);
      }
    } else {
      if(!this.isPermitted('month', index)) return;
      this.activeMonth = index;
      console.log(this.activeMonth);
      this.emitActive.emit(this.activeYear * 12  + this.activeMonth);
    }
  }

  protected readonly Icons = Icons;
}
